import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from "@mui/system";
import './index.css';
import App from './App';
import theme from "./theme";
import { createBrowserRouter,RouterProvider } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';

const router = createBrowserRouter([
  {
    path:"/",
    element:<App/>,
    children:[
      {
        path:"/",
        element:<HomePage/>
      }
    ]
  }
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

